import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ReactQuillEditorModules } from "../../Utils/RectQuillEditorConfig";
import css from "./AddContractClauseModal.module.css";
import Input from "../../Components/Form/Input/Input";
import Button from "../../Components/Button/Button";
import { Post, Error } from "../../Services/Server";
import Url from "../../Services/Url";
import { toast } from "react-toastify";
import { ModalAction } from "../../Routes/NavRouter";

const AddContractClauseModal = ({ children }) => {
	const { closeModal, clause } = children;
	const [editorContent, setEditorContent] = useState("");
	const [clauseName, setClauseName] = useState("");
	const [isEditMode, setIsEditMode] = useState(false);
	const [modalTitle, setModalTitle] = useState("Add Clause");
	const nameInPutRef = useRef(null);

	useEffect(() => {
		if (clause) {
			setIsEditMode(true);
			setModalTitle("Edit Clause");
			setClauseName(clause.name);
			setEditorContent(clause.details);
		} else {
			setIsEditMode(false);
			setModalTitle("Add Clause");
		}
	}, [clause]);

	const handleClauseNameChange = (e) => {
		setClauseName(e);
	};

	const saveClause = () => {
		const currentName = nameInPutRef.current?.value?.trim() || "";
		if (!currentName) {
			toast.error("Clause name cannot be empty");
			return;
		}

		const data = {
			name: currentName,
			details: editorContent,
		};

		const operation = isEditMode
			? Post(Url.contract.editClause(clause.id), data)
			: Post(Url.contract.saveClause, data);

		const performOperation = () => {
			operation
				.then((resp) => {
					toast(isEditMode ? "Clause Edited" : "Clause Saved");
					closeModal(resp);
				})
				.catch((err) => {
					Error(err);
					toast.error(
						isEditMode ? "Failed to edit clause" : "Failed to save clause"
					);
				});
		};

		if (isEditMode) {
			ModalAction.confirm({
				title: "Confirm Edit Clause",
				text: "Are you sure you want to edit this clause? This will modify the clause in all associated contracts and templates.",
				exitText: "Cancel",
				okText: "Edit",
				onOk: performOperation,
			});
		} else {
			performOperation();
		}
	};

	return (
		<>
			<hr />
			<div className={css.AddContractClauseModal}>
				<Input
					onChange={() => {
						if (nameInPutRef.current) {
							setClauseName(nameInPutRef.current.value);
						}
					}}
				>
					{{
						label: "Clause Title",
						name: "clauseName",
						placeholder: "Enter clause title",
						type: "text",
						value: clauseName,
						inputRef: nameInPutRef,
					}}
				</Input>
				<p
					style={{
						color: "var(--blue)",
						fontWeight: 600,
						marginTop: "20px",
						marginBottom: "5px",
					}}
				>
					Clause Details
				</p>
				<ReactQuill
					theme="snow"
					modules={ReactQuillEditorModules}
					placeholder="Content goes here..."
					style={{ height: "50vh", marginBottom: "70px" }}
					value={editorContent}
					onChange={setEditorContent}
				/>
				<Button onClick={saveClause} className="Btn-Mid Active">
					{isEditMode ? "Edit Clause" : "Save Clause"}
				</Button>
			</div>
		</>
	);
};

export default AddContractClauseModal;
